import {
    getSlider
} from 'simple-slider/dist/simpleslider'


$(document).ready(() => {

    // HOME
    // Job slider
    var job = getSlider({
        container: document.getElementById('job-slider'),
        delay: 5,
        prop: 'opacity',
        unit: '',
        init: 0,
        show: 1,
        end: 0
    })
    // Locations slider
    var locations = getSlider({
        container: document.getElementById('locations-slider'),
        delay: 5,
        prop: 'opacity',
        unit: '',
        init: 0,
        show: 1,
        end: 0
    })
    // Hero slider
    var hero = getSlider({
        container: document.getElementById('hero-slider'),
        delay: 5,
        prop: 'opacity',
        unit: '',
        init: 0,
        show: 1,
        end: 0
    })
    // People slider
    var people = getSlider({
        container: document.getElementById('people-slider'),
        delay: 5,
        prop: 'opacity',
        unit: '',
        init: 0,
        show: 1,
        end: 0
    })
    var ourPeople = getSlider({
        container: document.getElementById('our-people-slider'),
        delay: 5,
        prop: 'opacity',
        unit: '',
        init: 0,
        show: 1,
        end: 0
    })
    // Early Career
    var earlyCareer = getSlider({
        container: document.getElementById('early-hero-slider'),
        delay: 5,
        prop: 'opacity',
        unit: '',
        init: 0,
        show: 1,
        end: 0
    })

    // Jobs
    $('.job-slider-container .slide-back').on('click', function (e) {
        e.preventDefault()
        job.prev()

    })
    $('.job-slider-container .slide-next').on('click', function (e) {
        e.preventDefault()
        job.next()
    })

    // Locations
    $('.passion-packaging-slider .slide-back').on('click', function (e) {
        e.preventDefault()
        locations.prev()
    })
    $('.passion-packaging-slider .slide-next').on('click', function (e) {
        e.preventDefault()
        locations.next()
    })

    // Hero
    $('.hero .slide-back').on('click', function (e) {
        e.preventDefault()
        hero.prev()
    })
    $('.hero .slide-next').on('click', function (e) {
        e.preventDefault()
        hero.next()
    })

    // People
    $('.life-twg .slide-back').on('click', function (e) {
        e.preventDefault()
        people.prev()
    })
    $('.life-twg .slide-next').on('click', function (e) {
        e.preventDefault()
        people.next()
    })

    $('.our-people .slide-back').on('click', function (e) {
        e.preventDefault()
        ourPeople.prev()
    })
    $('.our-people .slide-next').on('click', function (e) {
        e.preventDefault()
        ourPeople.next()
    })
   
});